import { Badge } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import type { ShopifyProduct, ShopifyVariant } from '@/hooks/queries/use-shopify-products-query';
import type { GiftProductConfig } from '@fluenceur/types';

// An UNLISTED Shopify product is buyable through a direct link but hidden from
// the storefront. Flag it so the brand knows why it is missing from the shop.
export function ProductUnlistedBadge({ status }: { status: ShopifyProduct['status'] }) {
  const { t } = useTranslation();

  if (status !== 'UNLISTED') return null;

  return (
    <Badge size="xs" variant="subtle" colorPalette="gray" flexShrink={0}>
      {t('flows.properties.gift.unlisted', 'Unlisted')}
    </Badge>
  );
}

// Helper to convert ShopifyProduct + variant to GiftProductConfig
export function toGiftProductConfig(
  product: ShopifyProduct,
  variant: ShopifyVariant
): GiftProductConfig {
  return {
    shopifyProductId: product.id,
    shopifyVariantId: variant.id,
    title: product.title,
    price: variant.priceInCents / 100, // Convert cents to dollars
    imageUrl: product.featuredImageUrl,
  };
}
